import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { makeCancelable } from '../../../../utils/make-cancelable-promise';
export default class AccessibleSocialButton extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "setAccessibilityStatus", isAccessible => {
      if (!this.iframeNode) {
        return;
      }
      this.iframeNode.setAttribute('tabindex', isAccessible ? 0 : -1);
      if (isAccessible) {
        this.iframeNode.removeAttribute('aria-hidden');
        return;
      }
      this.iframeNode.setAttribute('aria-hidden', true);
    });
    _defineProperty(this, "saveContainerNode", node => {
      this.containerNode = node;
    });
    this.attachScriptPromise = null;
  }
  componentDidMount() {
    const {
      attachScript,
      initButton,
      title
    } = this.props;
    this.attachScriptPromise = makeCancelable(attachScript());
    this.attachScriptPromise.promise.then(() => initButton(this.containerNode)).then(() => {
      this.iframeNode = this.containerNode.querySelector('iframe');
      this.setAccessibilityStatus(this.props.isAccessible);
      if (title) {
        this.iframeNode.setAttribute('title', title);
      }
    });
  }
  componentWillUnmount() {
    this.attachScriptPromise.cancel();
  }
  UNSAFE_componentWillReceiveProps(_ref) {
    let {
      isAccessible
    } = _ref;
    if (isAccessible !== this.props.isAccessible && this.iframeNode) {
      this.setAccessibilityStatus(isAccessible);
    }
  }
  render() {
    const {
      children
    } = this.props;
    return /*#__PURE__*/React.createElement("div", {
      ref: this.saveContainerNode
    }, children);
  }
}
//# sourceMappingURL=accessible-social-button.js.map